export default __webpack_public_path__ + "static/media/profile.2bdabf61.png";